import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2884071_5v9t7nwfjki.js',
});

export default FontIcon;